import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { ConsumerRewardHandlerProvider } from '../../providers/consumer-reward-handler';
import { ConsumerBusinessDetailPage } from '../../pages/consumer-business-detail/consumer-business-detail';

import { Globals } from '../../providers/globals';
import { Utils } from '../../helpers/utils';

@Component({
  selector: 'page-consumer-reward-detail',
  templateUrl: 'consumer-reward-detail.html',
})
export class ConsumerRewardDetailPage {
	filePath: any;	
	loader: any;
	qrCodeUrl: any;	
	caller: any;

	refreshDone: boolean = false;
	leftView: boolean = false;
	isLoading: boolean = false;

	lastRedeemDate: any;
	needsRefresh: boolean = false;

	apiCallQty: any = 0;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
		public alertCtrl: AlertController,
		public utils: Utils,
		public rewardProvider: ConsumerRewardHandlerProvider,
		public loadingCtrl: LoadingController,
		public globals: Globals,
	) {
		let reward = this.rewardProvider.selectedReward;

		this.filePath = this.globals.fileUrl;		

		this.qrCodeUrl = this.globals.dataUrl + "qrcode/" + reward.Id + '~' + reward.UserId;		   
	}

	ionViewDidEnter() {
		this.leftView = false;

		if(!this.rewardProvider.selectedReward.RedeemDate){
			this.reLoad();
		}		
	}	

	ionViewDidLeave(){
		this.leftView = true;
	}		

	reLoad(){
		if(this.apiCallQty==15){
			this.leftView = true;
			this.navCtrl.pop();
		}else{
			if(!this.refreshDone){
				this.isLoading = true;			
			}

			this.refreshDone = false;

			this.rewardProvider.getById({
				id: this.rewardProvider.selectedReward.Id, 
				cb: (reward)=>{
					if(!this.refreshDone){
						this.isLoading = false;			
					}	

					this.doShit(reward);

					this.lastRedeemDate = reward.RedeemDate;

			  		if(this.leftView==false){
				   		setTimeout(()=>{
				   			if(this.leftView==false && this.needsRefresh){
				   				this.refreshDone = true;
				   				this.apiCallQty++;
				   				this.reLoad();
				   			}			   			
				   		}, 2000);	 				  			
			  		}  		  					
				}
			})
		}
	}

	doShit(reward){
		this.rewardProvider.selectedReward = reward;

		if(reward.RedeemDate!=this.lastRedeemDate){
			let alert = this.alertCtrl.create({
				title: 'Reward redeemed',
				subTitle: 'Hope you enjoyed getting that reward. Keep at it!',
				buttons: ['Ok']
			});

			alert.present();				

			this.rewardProvider.updateReward(reward);
			
			this.needsRefresh = false;
		}else{
			this.needsRefresh = true;
		}
	}

	gotoBusiness(id){
		this.navCtrl.push(ConsumerBusinessDetailPage, {
			requiresReload: true,
			businessId: id
		});			
	}	
}



// WEBPACK FOOTER //
// ./src/pages/consumer-reward-detail/consumer-reward-detail.ts